import { VIDEO_STATUS, VIDEO_URL, VIDEO_RESET } from 'constants/actionTypes';
import { Map } from 'immutable';

const initialState = Map({
    videoUrl: undefined,
    videoStatus: undefined,
    method: undefined,
});

const video = (state = initialState, action) => {
    switch (action.type) {
        case VIDEO_URL:
            return state.merge({
                videoUrl: action.url,
            });
        case VIDEO_STATUS:
            return state.merge({
                videoStatus: action.status,
                method: action.method,
            });

        case VIDEO_RESET:
            return initialState;

        default:
            return state;
    }
};

export default video;
